import { QueryClient, QueryKey } from "@tanstack/react-query";

export const reloadFn = (client: QueryClient, queryKey: QueryKey) =>
	client.invalidateQueries({ queryKey, refetchType: "all" });

export const invalidateCache = (client: QueryClient, queryKey: QueryKey) =>
	client.invalidateQueries({ queryKey, refetchType: "none" });

export const capitalizeWords = (value: string): string =>
	value
		.toLowerCase()
		.split(" ")
		.filter(Boolean)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
